import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Header = styled.span(props => ({
    fontWeight: 600,
    fontSize: "10px",
    color: theme(props).typography.inactive.color,
    letterSpacing: 1,
    lineHeight: "20px",
    textTransform: "uppercase",
}));
